import { createIcon } from '../createIcon';

export const FigmaIconConfig = {
  name: 'FigmaIcon',
  height: 512,
  width: 384,
  svgPath: 'M277 170.7A85.35 85.35 0 0 0 277 0H106.3a85.3 85.3 0 0 0 0 170.6 85.35 85.35 0 0 0 0 170.7 85.35 85.35 0 1 0 85.3 85.4v-256zm0 0a85.3 85.3 0 1 0 85.3 85.3 85.31 85.31 0 0 0-85.3-85.3z',
  yOffset: 0,
  xOffset: 0,
  transform: ''
};

export const FigmaIcon = createIcon(FigmaIconConfig);

export default FigmaIcon;